import FEGORender from '@futuweb/fego-render';
import FEGOEditor from '@futuweb/fego-editor';

const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10,
}

function isH5() {
    let route = null;
    if (FEGORender) {
        const {
            store
        } = FEGORender;
        route = store.route;
    } else {
        const {
            app: {
                project
            }
        } = FEGOEditor
        route = project.route;
    }

    return route.now.pageType === PAGE_TYPE_ENUM.H5;
}

let isLogin = false;

if (window.FEGORender) {
    let {
        store: { variable },
    } = window.FEGORender;

    // 是否已登录
    isLogin = !!variable.data.UID;
}

export {
    isH5,
    isLogin
}
